export default {"src":"/_next/static/media/looking-ahead-lg.mono.c8dff446.svg","height":263,"width":508,"blurWidth":0,"blurHeight":0};